export function prettyError(error) {
  if (!error) return "Something went wrong.";

  if (typeof error === "string") return error;

  if (error.detail && typeof error.detail === "string") {
    return error.detail;
  }

  if (error.message && typeof error.message === "string") {
    return error.message;
  }

  if (typeof error === "object") {
    const parts = [];

    Object.entries(error).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        parts.push(`${key}: ${value.join(", ")}`);
      } else if (typeof value === "string") {
        parts.push(`${key}: ${value}`);
      } else if (value && typeof value === "object") {
        parts.push(`${key}: ${JSON.stringify(value)}`);
      }
    });

    if (parts.length) return parts.join(" | ");
  }

  return "Unable to process request.";
}